















import {Component, Prop, Vue} from "vue-property-decorator";
import {ILocalAudioTrack} from "agora-rtc-sdk-ng";

@Component({
  name: "DeviceTestAudio",
})
export default class DeviceTestAudio extends Vue {
  @Prop() audioTrack: ILocalAudioTrack;
  @Prop({default: true}) active: boolean;

  currentLevel = 0;

  timerId: number | null = null;

  get barStyles() {
      return {
          'clip-path': `inset(${100 - this.currentLevel * 100}% 0 0 0)`
      }
  }

  mounted() {
    this.timerId = window.setInterval(() => {
      if (this.audioTrack && this.active) {
        this.currentLevel = this.audioTrack.getVolumeLevel();
      }
      else {
        this.currentLevel = 0;
      }
    }, 300);
  }

  destroyed() {
    this.timerId && window.clearInterval(this.timerId as number);
  }
}
